export const BUDGET_SCOPES = [
    'Storefront',
    'Internal Glazing & Balaustrades',
    'Stairs',
    'Furnishing & fit-out',
    'Ornamental Metal',
    'Steel constructions',
    'Doors & Windows',
    'Partition Walls',
    'Maintenance',
    'Technology',
    'Art & Exhibition',
    'Other',
];